import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Link as RouterLink, RouteComponentProps } from '@reach/router';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components';
import SimplePageLayout from '../../components/SimplePageLayout';
import colors from '../../lib/colors';

interface Props {
  title?: string;
  body?: string;
  linkTo?: string;
  linkLabel?: string;
}
type NotFoundProps = RouteComponentProps & Props;

const NotFound = ({ title, body, linkTo, linkLabel }: NotFoundProps) => {
  const [t] = useTranslation();
  return (
    <SimplePageLayout>
      <h1
        css={css`
          color: ${colors.white};
        `}
      >
        {title || t('notFound.header', 'Tady nic není')}
      </h1>
      <p
        css={css`
          color: ${colors.sunriseViolet};
        `}
      >
        {body || t('notFound.subtextAdress', 'Stránka neexistuje.')}
      </p>
      <Link to={linkTo ?? '/'}>
        <Button
          css={css`
            margin-top: 0.67em;
          `}
          variant="warning"
          label={linkLabel || t('notFound.homeLink', 'Jít domů')}
        />
      </Link>
    </SimplePageLayout>
  );
};

export default NotFound;

const Link = styled(RouterLink)`
  display: block;
  margin: 12px 0;
  font-weight: 500;
  letter-spacing: 0;
  color: white;
  font-size: 11px;
  text-decoration: underline;
  text-align: center;
`;
